import React, { useEffect} from 'react'


import { Container } from 'react-bootstrap'



const VendorContact = props => {

	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])
	
	return (
		<div className="main">
			<Container className="text-center ">
				<h1>Contact Us</h1>

				<form className="py-5 mx-auto">
					<div className="form-group row">
						<div className="col">
						    Phone:
						</div>
						<div className="col">
						    801-317-3538
						</div>
					</div>
					<div className="form-group row">
						
						<div className="col">
						    Email:
						</div>
						<div className="col">
						    <span className="footer-email font-weight-bold" onClick={() => window.open(`mailto:info@choredoor.com`)}>info@choredoor.com</span>
						</div>
					</div>
		
				</form>
		
			</Container>
		</div>


		
	)
}

export default VendorContact;